import { useEffect, useState, } from 'react';
import {
	Box,
	Button,
	Column,
	Icon,
	IconButton as IB,
	Row,
	Slider,
	Text,
	useToast,
} from 'native-base';
import Animated, {
	Easing,
	useSharedValue,
	useAnimatedStyle,
	withTiming,
	withRepeat,
} from 'react-native-reanimated';
import WscInMeLogo from '../components/WscInMeLogo';
import _ from 'lodash';

const TIMING_OPTIONS = {
	duration: 500,
};


export default function Test(props) {

	const
		logoRotation = useSharedValue(0),
		logoStyle = useAnimatedStyle(() => {
			return {
				transform: [{ rotateZ: `${logoRotation.value}deg` }],
			};
		});

	useEffect(() => {
		logoRotation.value = withRepeat(withTiming(
			360, // degrees 
			{
				duration: 30 * 1000, // 30 seconds
				// easing: Easing.linear(Easing.ease),
			}
		), -1); // repeat forever
	}, []);
	
	return <Animated.View style={logoStyle}>
				<Box h={400} justifyContent="center" alignItems="center">
					<WscInMeLogo 
						width={250}
						height={250}
					/>
				</Box>
			</Animated.View>;
}